module.exports = __webpack_public_path__ + "img/phones.eb853c3b.gif";